var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ut-container-lg ut-text-center"},[_c('h2',{staticClass:"ut-pt-7 ut-text-lg ut-font-bold"},[_vm._v("404: Page not found")]),_c('br'),_vm._v("\n    "+_vm._s(_vm.msg)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }